import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageHeader } from '@openx/components-header/PageHeader';
import type { LalSegmentFormState } from '@openx/types/segments';
import { useTranslation } from 'react-i18next';
import { useInitialValues } from '../hooks/useInitialValues';
import { useSegmentContext } from '../utils/context/SegmentContext';
import { LalSegmentsForm } from './LalSegmentsForm';

type LalSegmentEditFormProps = {
  lalSegmentId: string;
  goBack: () => void;
};

export const LalSegmentEditForm = ({ lalSegmentId, goBack }: LalSegmentEditFormProps) => {
  const { t } = useTranslation();
  const { useLalSegmentFetch, useUpdateLookalikeSegment } = useSegmentContext();

  const { lalSegment, loading } = useLalSegmentFetch(lalSegmentId);
  const { updateLookalikeSegment, isUpdating } = useUpdateLookalikeSegment();

  const initialValues = useInitialValues('', lalSegment);

  const onSubmit = (values: LalSegmentFormState) => {
    updateLookalikeSegment(lalSegmentId, {
      definition: {
        lookalike_name: values.name,
        lookalike_seeds_aggregate_name: values.seed_name,
        seeds_estimated_reach: values.estimated_reach,
      },
      seedSegmentIds: values.seeds.map(seed => seed.id),
    });
  };

  const lalSegmentName = lalSegment?.lookalike_name ?? '';

  return (
    <PageHeader title={`${t('Edit')}: ${lalSegmentName}`} titlePrefix="OpenXSelect">
      {loading ? (
        <Loader />
      ) : (
        <LalSegmentsForm
          goBack={goBack}
          initialValues={initialValues}
          onSubmit={onSubmit}
          isSubmitting={isUpdating}
          isEdit
        />
      )}
    </PageHeader>
  );
};
